import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_VAGAS || 'https://backendrh.empresasgrupojr.com.br';

console.log('API_BASE_URL:', API_BASE_URL);

const api = axios.create({
  baseURL: API_BASE_URL,
});


export { API_BASE_URL };
export default api;
 